import React, { useState } from "react";
import Style from "styles/components/youtube_embed.module.scss";

const YoutubeEmbed = ({ videoId, title = "YouTube video" }) => {
  const [playing, setPlaying] = useState(false);
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  if (playing) {
    return (
      <div className={Style.embed}>
        <iframe
          className={Style.iframe}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className={Style.embed}>
      <button
        type="button"
        className={Style.thumb}
        onClick={() => setPlaying(true)}
        aria-label={`${title}を再生`}
      >
        <img src={thumbnailUrl} alt="" loading="lazy" />
        <span className={Style.playButton} aria-hidden="true">
          <svg viewBox="0 0 68 48" width="68" height="48">
            <path
              d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C.06,13.05,0,24,0,24s.06,10.95,1.48,16.26c.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-.13,27.1-1.55c2.93-.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"
              fill="#212121"
              fillOpacity="0.85"
            />
            <path d="M 45,24 27,14 27,34" fill="#fff" />
          </svg>
        </span>
      </button>
    </div>
  );
};

export default YoutubeEmbed;
